export const getFriendlyAuthErrorMessage = (error: unknown, fallback: string) => {
  const rawMessage =
    typeof error === "string"
      ? error
      : (error as { message?: string } | null)?.message || "";

  const message = rawMessage.toUpperCase();

  if (message.includes("ERROR SENDING CONFIRMATION EMAIL")) {
    return "Could not send confirmation email. Ask your admin to configure Supabase Auth email (Authentication > Providers > Email) and verify SMTP settings.";
  }

  if (message.includes("SIGNUPS NOT ALLOWED")) {
    return "Sign-ups are disabled for this project. Enable Email sign-ups in Supabase Authentication settings.";
  }

  if (message.includes("REDIRECT URL") && message.includes("NOT ALLOWED")) {
    return "This app URL is not in Supabase allowed redirect URLs. Add your current app URL in Authentication > URL Configuration.";
  }

  if (message.includes("USER_ALREADY_LINKED_TO_CHURCH")) {
    return "This email is already linked to another church account. Please use the original church login or contact support.";
  }

  if (message.includes("INVALID OR EXPIRED INVITATION")) {
    return "This invitation link is invalid or expired. Please ask your church admin to send a new invitation.";
  }

  return rawMessage || fallback;
};
